import {SAVE_TUTORIAL_DATA, FETCH_TUTORIAL_DATA} from "./type";

const initalState = {
    savetutorialdata: [],
    fetchtutorialdataResponse: []
};

const TutorialQuestions = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SAVE_TUTORIAL_DATA:
            return {
                ...state,
                savetutorialdata: payload
            };
        case FETCH_TUTORIAL_DATA:
            return {
                ...state,
                fetchtutorialdataResponse: payload
            };
        default:
            return {
                ...state,
            };
    }
};

export default TutorialQuestions;
